export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/mezzopiano-icon.svg?30179c12e1b63d18f502f45f35ecef1d";